// ink-component
import React, { ReactNode } from 'react';
import styled from 'styled-components';

export interface ListBodyProps {
  /** Contents */
  children?: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/* @internal */
export const StyledListBody = styled.div`
  -ms-grid-column: 1 / span 2;
  -ms-grid-row: 1 / span 2;
  grid-column: 1 / span 2;
  grid-row: 2;
`;

/**
 * @purpose Allows any components to be at the bottom of a ListItem
 * @categories layout
 * @group List
 */
export function ListBody(props: ListBodyProps) {
  if (!props.children) return null;

  return <StyledListBody data-testid={props['data-testid']}>{props.children}</StyledListBody>;
}

ListBody.defaultProps = {
  children: undefined,
  'data-testid': undefined,
};

ListBody.displayName = 'ListBody';

export default ListBody;
